import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import {ServiceConfig} from './service-config';
import { InterceptorService } from 'ng2-interceptors';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class FollowService {

  private host = ServiceConfig.host;
  public baseUrl = this.host + '/api/follow/getData';
  // public baseUrl = 'http://localhost/api/projects/';
  public data: any;
  public headers: Headers;
  public options: {};

  constructor(private http: HttpClient,
              private router: Router) {
    // console.log(this.data.token);
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
    this.options = {headers: this.headers};
  }
  public getData(idDB: number, keySearch: string) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + `?idDB=${idDB}&token=${this.data.token}` + (keySearch.length < 1 ? "" : `&keySearch=${keySearch}`);

    console.log("url : ",url);
    return this.http.get<any>(url, {});
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/follow.service.ts